module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/full.0fe19e0af51572a3b99b.jpg";